import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=3a164683&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=3a164683&prod&scoped=true&lang=less"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&id=3a164683&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a164683",
  null
  
)

export default component.exports